import React, { useState, useEffect } from 'react'
import { Button, Checkbox, Popover } from '@mui/material'
import '../../../../../style/filters.css' // Adjust the path as necessary

const AssetGroupFilter = ({ filterList, onChange, index, column, filterOptions }) => {
  const [tempFilters, setTempFilters] = useState([])
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleChange = (event) => {
    const { value, checked } = event.target
    setTempFilters((prev) => (checked ? [...prev, value] : prev.filter((item) => item !== value)))
  }

  // const handleApply = () => {
  //   onChange(tempFilters, index, column)
  //   handleClose()
  // }

  const handleApply = () => {
    const cleaned = tempFilters.filter(Boolean) // removes "", null, undefined
    // console.log('Applying filters:', cleaned) // Update state with cleaned filters
    onChange(cleaned, index, column)
    handleClose()
  }
  const handleReset = () => {
    setTempFilters([])
    onChange([], index, column)
    handleClose()
  }

  const open = Boolean(anchorEl)
  const id = open ? 'primary-url-filter-popover' : undefined

  // ✅ Sync tempFilters every time popover is opened
  useEffect(() => {
    if (open) {
      setTempFilters(filterList || [])
    }
  }, [open, filterList])

  return (
    <div>
      <Button
        aria-describedby={id}
        onClick={handleClick}
        variant="outlined"
        size="small"
        style={{ marginLeft: 8 }}
      >
        Asset Group Filters
      </Button>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        PaperProps={{
          style: {
            backgroundColor: '#424242',
            color: '#ffffff',
            padding: '16px',
            width: '300px',
          },
        }}
      >
        <div style={{ padding: '16px' }}>
          <h3 className="filter-title">Asset Group Filters</h3>
          <div style={{ maxHeight: '300px', overflow: 'auto', marginBottom: '16px' }}>
            {filterOptions.groupsAsset?.map((url, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center' }}>
                <Checkbox
                  checked={tempFilters.includes(url)}
                  onChange={handleChange}
                  value={url}
                  size="small"
                  style={{ color: 'inherit' }}
                />
                <span style={{ fontSize: '0.875rem', wordBreak: 'break-word' }}>{url}</span>
              </div>
            ))}
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <button onClick={handleReset} className="reset-button-filter">
              Reset
            </button>
            <button onClick={handleApply} className="apply-button-filter">
              Apply
            </button>
          </div>
        </div>
      </Popover>
    </div>
  )
}

export default AssetGroupFilter
